enum ApiKeyScope {
  PLATFORM = "PLATFORM",
  COMPANY = "COMPANY",
}

export default ApiKeyScope;
